
import { mapState, mapGetters } from 'vuex';
import AuthorGrade from '@/enums/AuthorGrade';

export default {
  name: 'AppReviewUserInfoSectionListPc',
  props: {
    review: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapGetters('reviewSettings', [
      'isAuthorDisplayTypeUserGrade',
      'isAuthorDisplayTypeAuthorType'
    ]),
    shouldDisplayReviewOptions() {
      return (
        !!this.review.customer_properties &&
        this.review.customer_properties.length > 0
      );
    },
    shouldDisplayProductOptions() {
      return (
        this.reviewSettings.show_options &&
        this.review.product_options.length > 0
      );
    },
    userReviewOption() {
      if (this.isAuthorDisplayTypeUserGrade && this.review.brand_user_grade) {
        return {
          name: this.$t('user_grade'),
          value: this.review.brand_user_grade.name
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.brand_author_type) {
        return {
          name: this.$t('author_grade'),
          value: this.review.brand_author_type.title
        };
      }

      if (this.isAuthorDisplayTypeAuthorType && this.review.author_grade) {
        return {
          name: this.$t('author_grade'),
          value: AuthorGrade.t(this.review.author_grade)
        };
      }

      return null;
    }
  }
};
